module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-instagram.167795a1.svg";